"use client"

import SelectImageButton from "@/(admin)/components/image/select-image-button"
import { fetchMediaId } from "@/(admin)/modules/media/services/apiServices"
import { t } from "@/languages/i18n"
import { CustomerFieldConfig, CustomerFieldType, CustomerTableProps, MediaData } from "@/types/types"
import { Col, Form, FormItemProps, Input, Radio, Row, Select } from "antd"
import { Rule } from "rc-field-form/es/interface"
import React, { useEffect, useState } from "react"
import { getLeftColumnFields, getRightColumnFields } from "../constants/customerConstants"

const CustomerTable: React.FC<CustomerTableProps> = ({ form, onFinish, onFinishFailed, onFormChange }) => {
  const [selectedSignatureMedia, setSelectedSignatureMedia] = useState<MediaData[]>([])

  const signatureValue = Form.useWatch("signature", form)
  useEffect(() => {
    if (signatureValue && signatureValue !== "" && signatureValue !== null && signatureValue !== undefined) {
      const loadSignatureMedia = async () => {
        try {
          const mediaId = Number(signatureValue)
          if (!isNaN(mediaId) && mediaId > 0) {
            const media = await fetchMediaId(mediaId)
            if (media) {
              const mediaObj: MediaData = {
                id: media.id || mediaId,
                attributes: media.attributes || media,
              } as MediaData
              setSelectedSignatureMedia([mediaObj])
            }
          }
        } catch (error) {
          setSelectedSignatureMedia([])
        }
      }
      loadSignatureMedia()
    } else {
      setSelectedSignatureMedia([])
    }
  }, [signatureValue])

  const renderFormField = (fieldConfig: CustomerFieldConfig) => {
    const { name, labelKey, type, rules, initialValue, placeholder, options } = fieldConfig

    const translatedRules = rules?.map((rule: Rule) => {
      if (typeof rule === "object" && rule !== null && "message" in rule && typeof rule.message === "string") {
        return {
          ...rule,
          message: t(rule.message),
        }
      }
      return rule
    })

    const formItemProps: FormItemProps = {
      label: t(labelKey),
      name: name,
      rules: translatedRules,
      initialValue,
    }

    switch (type) {
      case "media":
        // Hiện tại chỉ dùng cho field "signature"
        if (name === "signature") {
          return (
            <Form.Item<CustomerFieldType> key={name} {...formItemProps}>
              <SelectImageButton
                selectedMedia={selectedSignatureMedia}
                setSelectedMedia={(value: MediaData[]) => {
                  setSelectedSignatureMedia(value)
                  form.setFieldValue("signature", value.length > 0 ? String(value[0].id) : undefined)
                  if (onFormChange) {
                    (onFormChange as any)();
                  }
                }}
                selectMode="single"
              />
            </Form.Item>
          )
        }
        return null

      case "select":
        return (
          <Form.Item<CustomerFieldType> key={name} {...formItemProps}>
            <Select>
              {options?.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  {t(option.label)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )

      case "radio":
        return (
          <Form.Item<CustomerFieldType> key={name} {...formItemProps}>
            <Radio.Group buttonStyle="solid">
              {options?.map(option => (
                <Radio.Button key={String(option.value)} value={option.value}>
                  {t(option.label)}
                </Radio.Button>
              ))}
            </Radio.Group>
          </Form.Item>
        )

      case "input":
      default:
        return (
          <Form.Item<CustomerFieldType> key={name} {...formItemProps}>
            <Input placeholder={placeholder ? t(placeholder) : undefined} />
          </Form.Item>
        )
    }
  }

  const leftColumnFields = getLeftColumnFields()
  const rightColumnFields = getRightColumnFields()

  return (
    <div className="w-full">
      <Form
        form={form}
        name="customerForm"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        autoComplete="off"
        onValuesChange={onFormChange}
      >
        <Row gutter={24}>
          {/* Cột trái */}
          <Col span={12}>{leftColumnFields.map(renderFormField)}</Col>

          {/* Cột phải */}
          <Col span={12}>{rightColumnFields.map(renderFormField)}</Col>
        </Row>
      </Form>
    </div>
  )
}

export default CustomerTable
